import type { FaireProductEntity } from "../../entity_types/product";

export const p_8eqpgrj87h: FaireProductEntity = {
  token: "p_8eqpgrj87h",
  type: "product",
  name: "Knot Moccasins - Genuine Leather Baby Shoes (Desert Rose)",
  brandToken: "b_5ytgyrzl",
  brandName: "BirdRock Baby",
  imageUrl:
    "https://cdn.faire.com/fastly/d9c558739eb95e4fbc694da64dcfa7f34c0dfd1d99f2451c285341eadcdebc1c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7260a721d321dfef5d8107ec95492581eb86e04c79fd7e186f5c4ad7f587a5ed.jpeg",
    "https://cdn.faire.com/fastly/43359146cd1d526885317c80b02dd042f82d1a0798f73ce3f6e47458447d1d65.jpeg",
    "https://cdn.faire.com/fastly/3eccfb029a54e7eb8fe0ecd2cf4c46d4f638d36c1dd498ac7e042e99ef4d1bf1.jpeg",
    "https://cdn.faire.com/fastly/fb64b3d107136b495537efeb42a8ca3e875c98816784e0b883f5cbdeae2cc0db.jpeg",
    "https://cdn.faire.com/fastly/d056d369fa32d5abab8ef84e44f1f5833d45e989f3b72ccc2a98efac3148439c.png",
  ],
  priceDollars: 15,
  description:
    'The Desert Rose Knot Moccasin is a subdued pink shade that is perfect for any occasion.\n\nSizing: \nUS 2 (0-6 Months, 3.75" Sole).\nUS 3 (3-6 Months; 4.125" Sole)\nUS 4 (6-12 Months, 4.5" Sole).\nUS 5.5 (12-18 Months, 5.0" Sole).\nUS 6.5 (18-24 Months, 5.25" Sole).\nUS 8 (2-3 Years, 5.75" Sole).\n',
  tags: [],
  msrpDollars: 30,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:45.563Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
